import { render, staticRenderFns } from "./ScoreByCategoryList.vue?vue&type=template&id=06bda454&"
import script from "./ScoreByCategoryList.vue?vue&type=script&lang=js&"
export * from "./ScoreByCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports